import { TableCell, TableRow } from "@mui/material";
import DotLegalNavigationIcon from "../../common/navigationIcon/DotLegalNavigationIcon";
import DotLegalTableCheckboxCell from "../../common/table/DotLegalTableCheckboxCell";
import { ApplicationUser } from "../users/User.types";
import { useBulkRenewalSelection } from "./bulkRenewal/BulkRenewalContext";
import { isCalculatedRenewal } from "./Case.functions";
import { Case, CaseType } from "./Case.types";
import { CaseSummarization } from "./CaseSummarizationPage";
import CaseTableRow from "./CaseTableRow";
import RenewalOverflowMenu from "./RenewalOverflowMenu/RenewalOverflowMenu";
import useCaseTableRowStyles from "./UseCaseTableRowStyles";

export type CaseTableRowProps = {
    case: Case;
    onCaseSelected: (caseSelection: { caseId: number; country: string }) => void;
    onRenewalRemarkSelected: (internalId: string) => void;
    onRenewalPriceChange?: (selectedCase: { internalId: string; price: string | null; remark: string }) => void;
    onCaseUpdated?: (updatedCase: Case) => void;
    caseType: CaseType;
    caseSummarization?: CaseSummarization;
    showRenewalPrice?: boolean;
    editRenewalPrice?: boolean;
    editSetRenewalStatus: boolean;
    renewalRegistrationActive: boolean;
    verifiedUser: ApplicationUser | null;
};

function CaseTableRowWrapper(props: CaseTableRowProps) {
    const styles = useCaseTableRowStyles();
    const bulkRenewalSelection = useBulkRenewalSelection();

    return (
        <TableRow className={isCalculatedRenewal(props.case) ? styles.calculatedRenewalRow : undefined}>
            {bulkRenewalSelection && <BulkRenewalCheckboxCell case={props.case} />}
            <CaseTableRow {...props} />
            <TableCell
                onClick={(event) => {
                    if (props.caseSummarization !== CaseSummarization.Renewals)
                        props.onCaseSelected({
                            caseId: props.case.id,
                            country: props.case.country,
                        });
                    event.stopPropagation();
                }}
                align="right"
            >
                {props.caseSummarization === CaseSummarization.Renewals ? <RenewalOverflowMenu {...props} /> : <DotLegalNavigationIcon />}
            </TableCell>
        </TableRow>
    );
}

function BulkRenewalCheckboxCell(props: { case: Case }) {
    const bulkRenewalSelection = useBulkRenewalSelection();
    if (!bulkRenewalSelection) return null;

    const selectability = bulkRenewalSelection.getSelectability(props.case);
    return (
        <DotLegalTableCheckboxCell
            tooltip={selectability.reason}
            disabled={!selectability.selectable}
            checked={selectability.selectable && bulkRenewalSelection.isSelected(props.case)}
            onChange={(checked) => bulkRenewalSelection.onSelectedChanged(props.case, checked)}
        />
    );
}

export default CaseTableRowWrapper;
